import dayjs from 'dayjs';
import { productElems } from './productParams';

const idPriority = [5, 3, 1, 17, 19];

//compute heat index for a single hour or all hours in a day
export function heatindex(tempVals, rhumVals, nacode='na') {
	const hindx = [];
	const temps = typeof tempVals !== "object" ? [tempVals] : tempVals;
	const rhums = typeof rhumVals !== "object" ? [rhumVals] : rhumVals;
	for (let i = 0; i < temps.length; i += 1) {
		if (temps[i] === "M" || rhums[i] === "M") {
			hindx.push("M")
		} else if (parseFloat(temps[i]) > 80) {
			let temp = parseFloat(temps[i])
			let rhum = parseFloat(rhums[i])
			let hi = Math.round(-42.379 + 2.04901523 * temp + 10.1433127 * rhum - 0.22475541 * temp * rhum -
				0.00683783 * (temp**2) - 0.05481717 * (rhum**2) + 0.00122874 * (temp**2) * rhum +
				0.00085282 * temp * (rhum**2) - 0.00000199 * (temp**2) * (rhum**2))
			if (rhum < 13 && temp >= 80 && temp <= 112) {
				const adj = ((13.0 - rhum) / 4.0) * Math.sqrt((17.0 - Math.abs(temp - 95.0)) / 17.0)
				hi -= adj
			}
			if (rhum > 85 && temp >= 80 && temp <= 87) {
				const adj2 = ((rhum - 85.0) / 10.0) * ((87.0 - temp) / 5.0)
				hi -= adj2
			}
			hindx.push(hi);
		} else {
			hindx.push(nacode);
		}
	}
	return typeof tempVals === "object" ? hindx : hindx[0];	
}

//compute wind chill from temp and wind speed for single hour or all hours in a day
export function windchill(tempVals, windVals, nacode='na') {
	const wchill = [];
	const temps = typeof tempVals !== "object" ? [tempVals] : tempVals;
	const winds = typeof windVals !== "object" ? [windVals] : windVals;
	for (let i = 0; i < temps.length; i += 1) {
		if (temps[i] === "M" || winds[i] === "M") {
			wchill.push("M")
		} else if (parseFloat(temps[i]) <= 50 && parseFloat(winds[i]) > 3) {
			let temp = parseFloat(temps[i])
			let wind = parseFloat(winds[i])
			wchill.push(Math.round(35.74 + (0.6215 * temp) - (35.75 * wind**0.16) + (0.4275 * temp * wind**0.16)));
		} else {
			wchill.push(nacode);
		}
	}
	return typeof tempVals === "object" ? wchill : wchill[0];
}

//compute relative humidity for a single hour
export function relativehumidity(dryBulbF, dewPointF, missing) {
	if (dryBulbF !== missing && dewPointF !== missing) {
		const dryBulbC = (dryBulbF - 32) * 5/9;
		const dewPointC = (dewPointF - 32) * 5/9;
		// constants based on Tetens formula
		const e_s = Math.exp((17.27 * dryBulbC) / (dryBulbC + 237.3));
		const e_d = Math.exp((17.27 * dewPointC) / (dewPointC + 237.3));
		const rh = (e_d / e_s) * 100;
		return rh
	} else {
		return missing
	}
}

//estimate wetbulb
export function wetbulb(dryBulbF, dewPointF, relhum, missing) {
	if (relhum === missing) {
		relhum - relativehumidity(dryBulbF, dewPointF, missing);
	}
	if (dryBulbF !== missing && relhum !== missing) {
		const dryBulbC = (dryBulbF - 32) * 5/9;
		// Stull formula
		const wetBulbC = dryBulbC * Math.atan(0.151977 * Math.sqrt(relhum + 8.313659)) +
			0.00391838 * Math.pow(relhum, 1.5) * Math.atan(0.023101 * relhum) -
			Math.atan(relhum - 1.676331) +
			Math.atan(dryBulbC + relhum) -
			4.686035;
		// Convert wet bulb temperature from Celsius to Fahrenheit
		const wetBulbF = (wetBulbC * 9/5) + 32;
		return wetBulbF;
	} else {
		return missing
	}
}

//cloud cover abbreviation to cloud cover as fraction (0-1)
export function tsky(value, obscured) {
	var rval;
	const layers = value.split(" ");
    const topLayer = layers[layers.length-1];
    if (topLayer.slice(0,2) === "VV") {
         rval = obscured
    } else {
		const cover = topLayer.slice(0,3);
		switch (cover) {
			case "CLR":
				rval = 0;
				break;
			case "FEW":
				rval = 0.25;
				break;
			case "SCT":
				rval = 0.5;
				break;
			case "BKN":
				rval = 0.75;
				break;
			case "OVC":
				rval = 1.0;
				break;
			default:
				rval = "M";
				console.log('Unknown cloud cover ' + cover);
		}
	}
	return rval;
}	

//estimate missing value in array of data (allData)
//pos_to_est is the position in the array of the value to be estimated
//element_position is place in hourly record of variable of interest (e.g., 5 if just one element in record)
export function estmiss(allData, pos_to_est, element_position) {
	const hourlyData = []
	// extract up to 3 hours before and after value of interest
	const slice_start = Math.max(pos_to_est - 3, 0)
	const slice_end = Math.min(pos_to_est + 3, allData.length - 1)
	for (let x = slice_start; x <= slice_end; x += 1) {
		hourlyData.push(allData[x][element_position])
	}
	// use this subset to produce estimate for desired hour
	const hr_to_est = pos_to_est - slice_start
	const missing = hourlyData[hr_to_est];
	var est = missing, prev = missing, next = missing, check = hr_to_est - 1;
	if (! [-999, "M"].includes(missing)) {
		console.log('Warning: unexpected missing value code ' + missing)
	}
	while (prev === missing && check >= 0) {
	  if (hourlyData[check] !== missing) {
		prev = hourlyData[check];
	  }
	  check -= 1;
	}
	check = hr_to_est + 1
	while (next === missing && check < hourlyData.length) {
	  if (hourlyData[check] !== missing) {
		next = hourlyData[check];
	  }
	  check += 1;
	}
	prev = prev === missing ? next : prev;
	next = next === missing ? prev : next;
	est = (prev !==  missing && next != missing) ? (next+prev)/2 : missing;
	return est;
}

export function dateParts(resDate) {
	var mm, dd, dow, mmdd, hh;
	const datadate = new Date(resDate.slice(0, 10)+"T00:00:00"); //need to add a time to get specified date, otherwise it gives local time corresponding to midnight UTC
	hh = parseInt(resDate.slice(11, 13));
	// change midnight from hour 0 to hour 24 the previous day
	if (hh === 0) {
	  const yest = new Date(datadate)
	  yest.setDate(datadate.getDate() - 1);
	  mm = yest.getMonth() + 1;
	  dd = yest.getDate();
	  dow = yest.getDay();               //day of week 
	  mmdd = String(mm).padStart(2, '0') + "-" + String(dd).padStart(2, '0');
	  hh = 24;
	} else {
	  mmdd = resDate.slice(5, 10);
	  dow = datadate.getDay();          //day of week
	}
	return [mmdd, hh, dow]
}

export function passesFilter(resDate, filters) {
	const [mmdd, hh, dow] = dateParts(resDate);
	const {sd, ed, hours_to_use, days_to_use} = filters;
	return ((sd <= ed && mmdd >= sd && mmdd <= ed) || (sd > ed && (mmdd >= sd || mmdd <= ed))) &&
		hours_to_use.includes(hh) &&
		days_to_use.includes(dow);
}

export function setupFilters(userParams) {
	let sd, ed, filters = {}
	if (userParams.fromFilterDay && userParams.toFilterDay) {
	  //day filter dates
	  sd = [userParams.fromFilterMonth.toString().padStart(2, '0'), userParams.fromFilterDay.toString().padStart(2, '0')].join("-")
	  ed = [userParams.toFilterMonth.toString().padStart(2, '0'), userParams.toFilterDay.toString().padStart(2, '0')].join("-")
	} else if (userParams.fromFilterMonth && userParams.toFilterMonth) {
	  //just month (1-12) filter; set to dates encompassing entire months
	  const dim = dayjs('2024-' + userParams.toFilterMonth.toString() + '-01').daysInMonth()
	  sd = [userParams.fromFilterMonth.toString().padStart(2, '0'), '01'].join("-")
	  ed = [userParams.toFilterMonth.toString().padStart(2, '0'), dim.toString().padStart(2, '0')].join("-")
	}
	filters = {...filters, sd, ed} 
	let hours_to_use = []
	if (userParams.fromFilterHour && userParams.toFilterHour) {
	  //build hour filter
	  const sh = userParams.fromFilterHour
	  const eh = userParams.toFilterHour
	  for (let k = 1; k <= 24; k += 1) {
		if ((sh <= eh && k >= sh && k <= eh) || (sh > eh && (k >= sh || k <= eh))) {
		  hours_to_use.push(k)
		}
	  }
	} else {
	  hours_to_use = Array.from({ length: 24 }, (_, i) => i + 1)
	}
	filters = {...filters, hours_to_use}
	//day of week filter
	const days_to_use = userParams.weekdays ? userParams.weekdays : [0,1,2,3,4,5,6];
	filters = {...filters, days_to_use}
	//return filters object
	return filters
}

export function getAcisData(userParams) {
	return new Promise((resolve, reject) => {
	  const url = userParams.hasOwnProperty("grid") ? "https://grid2.rcc-acis.org/GridData" : "https://stn2-ebd5.rcc-acis.org/StnData";
	  const options = {
		  method: "POST",
		  headers: { "Content-Type": "application/json" },
		  body: JSON.stringify(userParams)
	  };
	  var acisStatus = "";
	  fetch(url, options)
	  .then(res => res.json())
	  .then(res => {
		  if (res.error) {
			acisStatus = res.error;
			reject({acisStatus});
		  } else {
			acisStatus = null;
			resolve({...res, ...{acisStatus}});
		  }
		})
		.catch(err => {
		  console.log(err);
		  acisStatus = err;
		  reject({acisStatus});
		});
	})
}

const determineBbox = (srchCenter, srchRadius) => {
	const lat = srchCenter.lat;
	const lon = srchCenter.lng;
	const lat_offset = srchRadius / 69.047;
	const lon_offset = srchRadius / (69.17 * Math.cos(lat * 0.01745));
	const srchBbox = [lon - lon_offset, lat - lat_offset, lon + lon_offset, lat + lat_offset];
	return srchBbox;
}
  
export function doLocationSearch(srchName, srchRadius) {
	const token = process.env.REACT_APP_MAPQUEST_KEY;
	return new Promise((resolve, reject) => {
		const url = "https://www.mapquestapi.com/geocoding/v1/address?location=" + srchName + 
				"&inFormat=kvp&outFormat=json&thumbMaps=false&key="+token;
		if (srchName === "test") {
			const srchCenter = {lat:42, lng:-76}
			const srchBbox = determineBbox(srchCenter, srchRadius);
			resolve({srchBbox, srchCenter})
		} else {
		fetch(url)
			.then(res => res.json())
			.then(data => {
				if (data.info.statuscode === 0) {
					const srchCenter = data.results[0].locations[0].latLng;
					const srchBbox = determineBbox(srchCenter, srchRadius);
					resolve({srchBbox, srchCenter});
				} else {
					reject(data.info.statuscode);
				}
			})
			.catch(error => {
				reject(error.message);
			})
		}
	})
}

const geoDistance = (pt1, pt2) => {
	const lat1 = pt1.lat, lng1 = pt1.lng, lat2 = pt2.lat, lng2 = pt2.lng;
	if ((lat1 === lat2) && (lng1 === lng2)) {
		return 0;
	} else {
		const radlat1 = Math.PI * lat1/180;
		const radlat2 = Math.PI * lat2/180;
		const theta = lng1-lng2;
		const radtheta = Math.PI * theta/180;
		let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
		if (dist > 1) {
			dist = 1;
		}
		dist = Math.acos(dist);
		dist = dist * 180/Math.PI;
		dist = dist * 60 * 1.1515;
		return dist;
	}
}

const selectId = (sids) => {
	var bestPriority = 999, bestId = null;
	sids.forEach(function(id) {
		let split_id = id.split(" ");
		let network = parseInt(split_id[1], 10);
		let priority_index = idPriority.findIndex(function(p) {
			return p === network;
		});
		if (priority_index >= 0 && priority_index < bestPriority) {
			bestPriority = priority_index;
			bestId = id;
		}
	})
	return bestId;
}

const getInfoFromMeta = (metaResults, srchCenter) => {
	//const whichVdr = metaResults.hasOwnProperty("valid_daterange") ? metaResults.valid_daterange.findIndex((m) => m.length > 0) : -1;
	const whichVdr = metaResults.hasOwnProperty("valid_daterange") ? 1 : -1;
	if (whichVdr >= 0) {
		const sid = selectId(metaResults.sids);
		const vdr = metaResults.valid_daterange[0].substr(0,4) + " - " + metaResults.valid_daterange[1].substr(0,4);
		const name = metaResults.name + ', ' + metaResults.state;
		if (sid) {
			return {
				id: sid,
				name: name,
				distance: srchCenter ? geoDistance(srchCenter, {lat: metaResults.ll[1], lng: metaResults.ll[0]}) : null,
				position: [ metaResults.ll[0], metaResults.ll[1]],
				name_and_vdr: name + " (" + vdr + ")",
			};
		};
	}
	return null;
}

const sortByDistance = (a, b) => {
	const x = a.distance, y = b.distance;
	return ((x < y) ? -1 : ((x > y) ? 1 : 0));
}

export function processMetaResults(meta, srchCenter=null) {
	let nearbyStns = [];
	for (let j = 0; j < meta.length; j += 1) {
		const metaObj = getInfoFromMeta(meta[j], srchCenter);
		if (metaObj) {
			nearbyStns.push(metaObj);
		}
	}
	nearbyStns.sort(sortByDistance);
	return nearbyStns;
}

export function getStationList(bbox, srchCenter, product) {
	return new Promise((resolve, reject) => {
		const params = {
			bbox: bbox,
			meta: "name,state,sids,valid_daterange,ll",
		};
		const options = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(params)
		};
		fetch("https://stn2-ebd5.rcc-acis.org/StnMeta", options)
			.then(res => res.json())
			.then(data => {
				const meta = data.meta;
				const stationList = processMetaResults(meta, srchCenter);
				if (stationList.length) {
					resolve(stationList);
				} else {
					reject("No matches");
				}
			})
			.catch(err => {
				console.log("ACIS Request Error: " + err);
				reject(err);
			});
	});
}

export function getStnMetaData(id, product, signal) {
	return new Promise((resolve, reject) => {
		let stnName = "";
		const allVdr = []
		const params = {
			sids: id,
			meta: "name,state,valid_daterange",
		};
		const options = {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify(params),
			signal: signal,
		};
		fetch("https://stn2-ebd5.rcc-acis.org/StnMeta", options)
			.then(res => res.json())
			.then(data => {
				const meta = data.meta;
				if (meta.length > 0) {
					stnName = meta[0].name + ", " + meta[0].state;
//					let mnvdr = "9999-99-99"
//					let mxvdr = "0000-00-00"
//					if (meta[0].valid_daterange.length) {
//						meta[0].valid_daterange.forEach((vdr, i) => {
//							if (vdr.length > 0) {
//								if (vdr[0] < mnvdr) {
//									mnvdr = vdr[0]
//								}
//								if (vdr[1] > mxvdr) {
//									mxvdr = vdr[1]
//								}
//								allVdr.push([elems[i], vdr[0], vdr[1]])
								allVdr.push(['all', meta[0].valid_daterange[0], meta[0].valid_daterange[1]])
//							}
//						})
						stnName += " (" + meta[0].valid_daterange[0].slice(0, 4) + " - " + meta[0].valid_daterange[1].slice(0, 4) + ")";
//					}
				} else {
					stnName = "Unknown id";
				}
				resolve({stnName, allVdr});
			})
			.catch(err => {
				reject(err);
			});
	});
}

